import {GOOGLE_CLOUD_FUNCTIONS_URL} from '../constants/network';

const DEFAULT_IP = '0.0.0.0';

export const getUserIp = async (): Promise<string> => {
  try {
    const res = await fetch(
      `${GOOGLE_CLOUD_FUNCTIONS_URL}/ip-reverse-geolocation`
    );
    const {userIP} = await res.json();

    return userIP;
  } catch (err) {
    return DEFAULT_IP;
  }
};
